import { z } from 'zod';
/** Exactly one of the three: a preference row belongs to one level and inherits down the chain. */
export const PracticePreferenceEntitySelectorSchema = z.union([
    z.object({ practiceId: z.uuid() }).strict(),
    z.object({ practiceGroupId: z.uuid() }).strict(),
    z.object({ organizationId: z.uuid() }).strict(),
]);
//# sourceMappingURL=entity.js.map